var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.close}},[_c('span',{attrs:{"aria-hidden":"true"}},[_c('font-awesome-icon',{attrs:{"icon":"fa-light fa-times"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }